// extracted by mini-css-extract-plugin
export default {"main":"styles_main__AxRbt","task":"styles_task__mpWdP"};